"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const BookmarkFilledIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.875 1.7c0-.387.304-.7.68-.7h10.89a.69.69 0 01.68.7v12.6a.7.7 0 01-.411.643.666.666 0 01-.736-.134L7.996 9.966l-4.973 4.843a.666.666 0 01-.737.134.7.7 0 01-.411-.643V1.7z",
    clipRule: "evenodd"
  })))
});
BookmarkFilledIcon.displayName = 'BookmarkFilledIcon';
var _default = exports.default = BookmarkFilledIcon;